import React from 'react';
const investors = [{
  name: 'Alchemist Accelerator',
  logo: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/alchemist-logo.png',
  href: 'https://www.alchemistaccelerator.com'
}, {
  name: 'Race Capital',
  logo: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/race-capital.png',
  href: 'https://www.race.capital'
}, {
  name: 'Antler',
  logo: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/antler.png',
  href: 'https://www.antler.co'
}, {
  name: 'Sunset Ventures',
  logo: 'https://cdn.magicpatterns.com/uploads/kgca5ua98Jg1TJMn6DQEPD/sunset_ventures_light_(1).png',
  href: 'https://x.com/SunsetVC'
}, {
  name: 'GoAhead Ventures',
  logo: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/goahead-ventures.png',
  href: 'https://www.goaheadvc.com/'
}];
export function VCLogos() {
  // Duplicate the list for seamless infinite scroll
  const allLogos = [...investors, ...investors];
  return <section className="relative w-full bg-navy pt-4 pb-8 overflow-hidden" data-id="element-343">
      {/* Top divider */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-2/3 h-px bg-gradient-to-r from-transparent via-white/[0.06] to-transparent" data-id="element-344" />

      <p className="text-center text-white/30 text-sm font-medium tracking-[0.2em] uppercase mb-10" data-id="element-345">
        Backed by leading investors
      </p>

      {/* Marquee container */}
      <div className="relative" data-id="element-346">
        {/* Left fade */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-navy to-transparent z-10 pointer-events-none" data-id="element-347" />
        {/* Right fade */}
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-navy to-transparent z-10 pointer-events-none" data-id="element-348" />

        <div className="flex animate-marquee" data-id="element-349">
          {allLogos.map((investor, index) => <a key={`${investor.name}-${index}`} href={investor.href} target="_blank" rel="noopener noreferrer" className="flex-shrink-0 mx-12 flex items-center justify-center group" data-id="element-350">
              <img src={investor.logo} alt={investor.name} className="h-16 w-auto max-w-[240px] object-contain transition-all duration-300 cursor-pointer brightness-0 invert" style={{
            opacity: 0.4
          }} onMouseEnter={e => {
            e.currentTarget.style.opacity = '1';
            e.currentTarget.style.filter = 'brightness(0) invert(1) drop-shadow(0 0 12px rgba(255,255,255,0.4))';
          }} onMouseLeave={e => {
            e.currentTarget.style.opacity = '0.4';
            e.currentTarget.style.filter = 'brightness(0) invert(1)';
          }} data-id="element-351" />
            </a>)}
        </div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-2/3 h-px bg-gradient-to-r from-transparent via-white/[0.06] to-transparent" data-id="element-352" />
    </section>;
}